<template>
	<div id="usre-baseinfor" class="oh">
		<leftnav class="fl" mkcode="F" itemcode="F-FWSC"></leftnav>
		<div class="index_left servicebook" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="right_topbox" style="min-height: 800px;">
					<div class="servicebookp">
						<div class="pagetitle">
							<h1>中投顾问产业招商大脑服务手册</h1>
							<p>全国首个saas版云端大数据精准招商、智慧招商平台</p>
						</div>
						<div class="flexdgbg">
							<a href="http://c.ocn.com.cn/special/cydnproduct/indexpx.html" target="_blank" class="adli1 fl">
								<h5>产业招商大脑十大功能 </h5>
								<p>提升工作效率几十倍</p>
							</a>
							<a href="https://share.plvideo.cn/album/index.html?albumId=4841dc66" target="_blank"
								class="adli4 fr">
								<h5>产业招商大脑使用操作说明 </h5>
								<p>用好五个功能模块协助做好招商工作</p>
							</a>
							<a href="http://c.ocn.com.cn/special/dashujukecheng/indexN.html" target="_blank"
								class="adli2 fl">
								<h5>大数据专业招商实战课</h5>
								<p>政府招商圈正在热传的招商培训课程</p>
							</a>
							<a href="https://share.plvideo.cn/album/index.html?albumId=1bac6d3d" target="_blank"
								class="adli3 fr">
								<h5>产业招商大脑视频专辑</h5>
								<p>快速了解产业招商大脑四大功能及其优势</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'servicebook',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			title: '服务手册',
			relationlist: [],
		}
	},
	created() {
		this.userdata = this.getuserinformain();
	},
	mounted() {

	},
	methods: {




	}
}  
</script>

<style></style>
